@if (base(); as base) {
  <div class="base-cell">
    <p>{{ base.name }}</p>

    <p class="f-body-s f-muted">
      <onyx-address
        [address]="base.address"
        format="short"
        [showFlag]="false"
      ></onyx-address>
    </p>
  </div>
} @else if (vehicle() || driver()) {
  <onyx-link
    color="blue"
    font="f-body-m f-medium"
    [inactive]="isArchived()"
    [onyxTooltip]="
      vehicle()
        ? 'fleet.fleetList.cells.cannotAssignBase'
        : 'drivers.driversList.cannotAssignBase'
    "
    [onyxTooltipDelay]="TOOLTIP_DELAY"
    [onyxTooltipDisabled]="!isArchived()"
    (click)="!isArchived() ? assignBase() : null; $event.stopPropagation()"
  >
    {{ 'labels.assign' | translate }}
  </onyx-link>
} @else {
  -
}
